<template>
  <!-- BEGIN pos-counter-content -->
  <div class="ts-p-6">
    <div class="ts-space-y-4">
      <label
        class="col-form-label ts-mb-3 ts-font-bold ts-w-full ts-px-2 bg-success ts-flex ts-justify-items-center ts-items-center"
        style="height: 45px;">
        <i class="fa fa-key fa-fw fa-lg ts-pb-1" style="color: white;"></i>
        <h4 style="margin: 0 !important;color: white;" class="ts-pl-2">{{ $t('restaurantSale.linkedKey') }}</h4>
      </label>
      <div class="ts-border-t ts-border-gray-300 ts-pt-4">
        <div class="pos pos-counter">
          <div class="pos-counter-body">
            <div class="pos-counter-content">
              <vue-custom-scrollbar class="pos-counter-content-container">
                <ts-loading-banner :loading="false">
                  <div class="table-row">
                    <TableCard v-for="(table, index) in tableLists" :key="index" :table="table"
                      :selected="checkSelected(table)" @click="onTableSelected(table)" />
                  </div>
                </ts-loading-banner>
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
        <div class="ts-py-1">
          <i>
            <span class="ts-text-xs">
              {{ $t('restaurantSale.totalLinked') + ' : ' + (model.linked_keys.length + 1) }} / {{ maxPerson + ' ' +
                $t('restaurantSale.keys') }}
            </span>
          </i>
        </div>
      </div>
      <div class="btn-row ts-space-x-2 ts-text-right ts-border-t ts-border-gray-300 ts-pt-4">
        <ts-button @click.prevent="$emit('cancel')"><i class="fa fa-arrow-left fa-fw fa-lg"></i>
          {{ $t('restaurantSale.back') }}</ts-button>
        <ts-button color="success" @click.prevent="linkedKey" :waiting="loading"
          :disabled="loading || (tableSelected.table_id ? false : true)"><i class="fa fa-shopping-cart fa-fw fa-lg"
            v-if="!loading"></i>
          {{ $t('restaurantSale.linkedKey') }}</ts-button>
      </div>
    </div>
  </div>
  <!-- END pos-counter-content -->
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import RecieptPreview from './reciept-preview'
import TableCard from './LinkedKeysTableCard.vue'

export default {
  props: ['tableSelected'],
  name: 'linkedKeys',
  components: {
    RecieptPreview,
    TableCard
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      model: {
        table_id: null,
        stock_out_id: null,
        linked_keys: [],
      },
      waiting: false,
    }
  },
  created() {
    this.setEditData(this.tableSelected)
  },
  computed: {
    tableLists() {
      return _.sortBy(this.$store.state.restaurantSale.counterCheckout.tables, [
        'display_order'
      ])
        .filter(table => table.guest_level_id == 2)
        .filter(table => table.status_id == 1 || this.tableSelected.linked_keys.some(el => el.table_id == table.table_id))
    },
    maxPerson() {
      return Math.max(
        ...this.tableSelected.invoice_detail.map(el => el.max_person)
      );
    },
  },
  methods: {
    fetchTables(attributes) {
      this.$emit('fetchTableByInterval', attributes);
      // this.$store
      //   .dispatch('restaurantSale/counterCheckout/fetchTables', attributes)
      //   .catch(error => {
      //     this.$notification['error']({
      //       message: 'FETCH TABLE',
      //       description: error.message,
      //       placement: 'bottomRight'
      //     })
      //   })
    },
    checkSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      return selected ? true : false
    },
    onTableSelected(table) {
      const selected = this.model.linked_keys.find(el => el.table_id == table.table_id)
      if (selected) {
        this.model.linked_keys.splice(
          this.model.linked_keys.indexOf(selected),
          1
        )
      } else {
        if (this.model.linked_keys.length >= (this.maxPerson - 1)) {
          this.$notification['warning']({
            message: 'LINKED KEY',
            description: 'Maximum ' + this.maxPerson + ' people has been reached!',
            placement: 'bottomRight'
          })
          return 0;
        }

        let row = {
          stock_out_linked_key_id: null,
          stock_out_id: this.model.stock_out_id,
          table_id: table.table_id,
          start_time: null,
          end_time: null
        }
        this.model.linked_keys.push(row)
      }
    },
    linkedKey() {
      this.loading = true
      this.$store
        .dispatch(
          'restaurantSale/counterCheckout/linkedKey', this.model)
        .then(response => {
          this.$notification['success']({
            message: 'LINKED KEY',
            description: response.message,
            placement: 'bottomRight'
          })
          this.$emit('cancel')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$notification['error']({
            message: 'LINKED KEY',
            description: error.message,
            placement: 'bottomRight'
          })
        })
        .finally(() => {
          this.fetchTables()
          this.loading = false
        })
    },
    setEditData(tableSelected) {
      this.model.table_id = tableSelected.table_id
      this.model.stock_out_id = tableSelected.stock_out_id
      this.model.linked_keys = tableSelected.linked_keys.map(el => ({
        stock_out_linked_key_id: el.stock_out_linked_key_id,
        stock_out_id: el.stock_out_id,
        table_id: el.table_id,
        start_time: el.start_time,
        end_time: el.end_time
      }))
    }
  }
}
</script>
<style scoped>
fieldset {
  border: 1px solid #ececec;
  padding: 10px 15px !important;
  border-radius: 4px;
}
</style>

<style scoped lang="scss">
.pos-counter {
  padding-top: 0;
  height: 400px !important;

  @media (max-width: 75em) {
    height: 400px !important;
  }

  @media (max-width: 54em) {
    height: 400px !important;
  }

  @media (max-width: 37.5em) {
    height: 350px !important;
  }
}

@media (max-width: 991.98px) {

  .pos-counter .pos-counter-header .logo,
  .time,
  .nav .nav-item {
    display: none;
  }
}
</style>
<style>
.ant-notification {
  z-index: 1030;
}
</style>